import React from "react";
import { $isSideCartOpen } from "../../utils/store";
import { __t } from "../../utils/translate";

type CartMenuProps = {
    className?: string;
};

export const CartMenuClose: React.FC<CartMenuProps> = ({ className }) => {
    return (
        <button
            className={`${className} relative h-6 w-6 overflow-hidden focus:outline-none`}
            aria-label="Close cart"
            onClick={() => $isSideCartOpen.set(false)}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M24.9428 8.94265C25.4635 8.42195 25.4635 7.57773 24.9428 7.05703C24.4221 6.53633 23.5779 6.53633 23.0572 7.05703L16 14.1142L8.94283 7.05703C8.42213 6.53633 7.57791 6.53633 7.05721 7.05703C6.53651 7.57773 6.53651 8.42195 7.05721 8.94265L14.1144 15.9998L7.05721 23.057C6.53651 23.5777 6.53651 24.4219 7.05721 24.9426C7.57791 25.4633 8.42213 25.4633 8.94283 24.9426L16 17.8855L23.0572 24.9426C23.5779 25.4633 24.4221 25.4633 24.9428 24.9426C25.4635 24.4219 25.4635 23.5777 24.9428 23.057L17.8856 15.9998L24.9428 8.94265Z" fill="#333" />
            </svg>
        </button>
    );
};

export const CartMenuOpen: React.FC<CartMenuProps> = ({ className }) => {
    return (
        <button
            className={`${className} relative flex items-center justify-end`}
            aria-label="Open cart"
            onClick={() => $isSideCartOpen.set(true)}
        >
            <PaperBagLogo />
        </button>
    );
};

const PaperBagLogo: React.FC = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M16 0C12.134 0 8.99998 3.13401 8.99998 7V9H7.50371C6.05385 9 4.81145 10.0369 4.5521 11.4633L1.64301 27.4633C1.30818 29.3049 2.7229 31 4.59462 31H27.4053C29.2771 31 30.6918 29.3049 30.3569 27.4633L27.4479 11.4633C27.1885 10.0369 25.9461 9 24.4962 9H23V7C23 3.13401 19.866 0 16 0ZM21 11V15H23V11H24.4962C24.9795 11 25.3937 11.3456 25.4801 11.8211L28.3892 27.8211C28.5008 28.435 28.0292 29 27.4053 29H4.59462C3.97071 29 3.49914 28.435 3.61074 27.8211L6.51984 11.8211C6.60629 11.3456 7.02042 11 7.50371 11H8.99998V15H11V11H21ZM21 9V7C21 4.23858 18.7614 2 16 2C13.2386 2 11 4.23858 11 7V9H21Z" fill="#083B66" />
        </svg>
    );
};
